/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import Container from '@mui/material/Container';
import { Link } from 'react-router-dom'




const PageNotFound = ( ) => {

  const { classes } = useStyles();
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        {/* Hero unit */}

        <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <Grid container spacing={1}>
            <Typography gutterBottom variant="h5">
              404 - {t('labels:pagenotfound')}
            </Typography>

          </Grid>

          <Grid container spacing={1}>
            <Button component={Link} to="/" variant="contained" color="primary">
              {t('labels:returnhome')}
            </Button>
          </Grid>
        </Container>
      </main>



    </React.Fragment>
  );
}
const useStyles = makeStyles({ "name": { PageNotFound } })((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  } 
}));


export default PageNotFound;